/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is the same proportional chart with the centre cut out, forming a ring. The information is identical; many people find the ring form cleaner and it leaves space in the middle.`)
};

const es_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es el mismo gráfico proporcional con el centro recortado, formando un anillo. La información es idéntica; muchas personas encuentran la forma de anillo más limpia y deja espacio en el medio.`)
};

const de_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist dasselbe proportionale Diagramm mit ausgeschnittener Mitte, das einen Ring bildet. Die Information ist identisch; viele Menschen empfinden die Ringform als übersichtlicher, und sie lässt Platz in der Mitte.`)
};

const nl_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is hetzelfde proportionele diagram met het midden uitgesneden, wat een ring vormt. De informatie is identiek; velen vinden de ringvorm overzichtelijker en het laat ruimte in het midden.`)
};

const fr_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est le même graphique proportionnel avec le centre découpé, formant un anneau. L'information est identique ; beaucoup trouvent la forme en anneau plus épurée et elle laisse de l'espace au centre.`)
};

const it_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È lo stesso grafico proporzionale con il centro tagliato via, che forma un anello. L'informazione è identica; molti trovano la forma ad anello più pulita e lascia spazio al centro.`)
};

const pt_br2_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o mesmo gráfico proporcional com o centro removido, formando um anel. A informação é idêntica; muitas pessoas acham a forma de anel mais limpa e ela deixa espaço no meio.`)
};

const pt_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o mesmo gráfico proporcional com o centro cortado, formando um anel. A informação é idêntica; muitas pessoas consideram a forma em anel mais limpa e ela deixa espaço no meio.`)
};

const ja_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央をくり抜いてリング状にした、同じ割合を示すグラフです。情報は同一ですが、多くの人はリング形の方がすっきりして見え、中央にスペースが残ります。`)
};

const zh_donut_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是同样展示占比的图表，只是将中心挖空形成一个环。信息完全相同；许多人认为环形更简洁，且中间留有空间。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_faq_a1", locale)
	if (locale === "en") return en_donut_faq_a1(inputs)
	if (locale === "es") return es_donut_faq_a1(inputs)
	if (locale === "de") return de_donut_faq_a1(inputs)
	if (locale === "nl") return nl_donut_faq_a1(inputs)
	if (locale === "fr") return fr_donut_faq_a1(inputs)
	if (locale === "it") return it_donut_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_donut_faq_a1(inputs)
	if (locale === "pt") return pt_donut_faq_a1(inputs)
	if (locale === "ja") return ja_donut_faq_a1(inputs)
	return zh_donut_faq_a1(inputs)
};